import React, { useEffect, useRef } from 'react';
import './style.scss'

import { useField } from '@unform/core';
import ReactInputMask, { Props as InputProps } from 'react-input-mask';

function Telefone({ name, col, celular = false, ...props }) {
    const inputRef = useRef(null);
    const { fieldName, registerField, defaultValue, error } = useField(name);

    useEffect(() => {
        registerField({
            name: fieldName,
            ref: inputRef.current,
            path: 'value',
            setValue(ref, value) {
                ref.setInputValue(value === null ? '' : value);
            },
            clearValue(ref) {
                ref.setInputValue('');
            },
        });
    }, [fieldName, registerField]);

    let mask = '(99) 9999-9999'
    if (celular)
        mask = '(99) 9 9999-9999'

    return (
        <div className={`cInputD ${col}`}>
            <span>{props.titulo}</span>
            <div className="input-group input-group-merge input-group-alternative">
                <ReactInputMask id={name} mask={mask} autoComplete='no' ref={inputRef} defaultValue={defaultValue} {...props} />
            </div>
            {error && <span className="error-validacao">{error}</span>}
        </div>
    );
}

export default Telefone